import axios from '@/libs/http'

/**
 * 获取新店员申请列表
 * */
export const getClerkApplyList = (status, sex, keyword, pageNo, pageSize) => {
    return axios.request({
        url: '/s/a/clerkApply/list',
        params: {
            status,
            sex,
            keyword,
            pageNo,
            pageSize
        },
        method: 'get'
    })
}

/**
 * 获取新店员申请详情
 * */
export const getClerkApply = (id) => {
    return axios.request({
        url: '/s/a/clerkApply/get',
        params: {
            id
        },
        method: 'get'
    })
}

/**
 * 修改新店员申请失败
 * */
export const updateClerkApply = (id, status, reason) => {
    let data = new URLSearchParams()
    data.append("id", id)
    data.append("status", status)
    if(reason != null){
        data.append("reason", reason)
    }
    return axios.request({
        url: '/s/a/clerkApply/update',
        data,
        method: 'post'
    })
}

/**
 * 添加成店员
 * */
export const addApplyToClerk = (id,groupId, categoryIds, ddUserId, verifyCode) => {
    let data = new URLSearchParams()
    data.append("id", id)
    if (groupId) data.append("groupId", groupId)
    if (categoryIds) data.append("categoryIds", categoryIds)
    if (ddUserId) data.append("ddUserId", ddUserId)
    if (verifyCode) data.append("verifyCode", verifyCode)

    return axios.request({
        url: '/s/a/clerkApply/addApplyToClerk',
        data,
        method: 'post'
    })
}

// 修改手机号
export const phoneClerk = (id, regionCode,mobile) => {
    let data = new URLSearchParams()
    data.append("id", id)
    data.append("regionCode", regionCode)
    data.append("mobile", mobile)
    return axios.request({
        url: '/s/a/clerkApply/updateMobile',
        data: data,
        method: 'POST'
    })
}
